import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import cookie from 'react-cookies';
import { OverlayTrigger, Tooltip, Row, Col } from 'react-bootstrap';
import Heading from '../components/Heading';
import DealsList from '../components/Deals/DealsList';
import PlanModal from '../components/UserPlan/PlanModal';

class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      planModalOpen: false,
      subscriptionPlan: 'free',
      isPremiumExpired: false,
    };
  }

  componentWillMount() {
    const signupPlan = cookie.load('signupPlan');
    // console.log('SIGNUP_PLAN_COOKIE', signupPlan)
    if (signupPlan && signupPlan !== 'free') {
      // show the subscriptin plan selected from pricing page before registration
      if (signupPlan === 'creg') {
        cookie.remove('signupPlan', {
          path: '/',
        });
        this.props.router.push('/copyright-reg');
      }
    } else {
      cookie.remove('signupPlan', {
        path: '/',
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { profile } = nextProps;

    if (profile) {
      if (
        (profile.subscription_plan === 'premium' &&
          profile.trial_expired === true) ||
        (profile.subscription_plan === 'free' &&
          (profile.referrer.includes('cdbaby') ||
            profile.referrer.includes('soundrop')))
      ) {
        // show payment modal for over trialed user
        this.setState({
          planModalOpen: true,
          subscriptionPlan: profile.subscription_plan,
          isPremiumExpired: true,
        });
      }
    }
  }

  hidePlanModal() {
    cookie.remove('signupPlan', {
      path: '/',
    });

    this.setState({ planModalOpen: false, canShowPlanModal: false });
  }

  render() {
    const { subscription, profile } = this.props;
    const { planModalOpen, subscriptionPlan, isPremiumExpired } = this.state;

    return (
      <div className="dashboard">
        <Heading text="Hello! Let's Get Started." />
        <Row className="content">
          <Col md={12} sm={12} className="dash-buttons">
            <div className="services create">
              <OverlayTrigger
                overlay={
                  <Tooltip id="tooltip-split">
                    Create agreements with your collaborators
                  </Tooltip>
                }
                placement="right"
              >
                <Link to={`/create/new`}>
                  <div className="service">
                    <div className="title">New Agreement</div>
                  </div>
                </Link>
              </OverlayTrigger>

              <OverlayTrigger
                overlay={
                  <Tooltip id="tooltip-split">
                    Add a new work title to an existing agreement that you made
                    on Cosynd
                  </Tooltip>
                }
                placement="right"
              >
                <Link to={`/create/exist`}>
                  <div className="service">
                    <div className="title">Add To An Existing Agreement</div>
                  </div>
                </Link>
              </OverlayTrigger>
            </div>

            <div className="services">
              <OverlayTrigger
                overlay={
                  <Tooltip id="tooltip-split">
                    Register your works with the U.S. Copyright Office
                  </Tooltip>
                }
                placement="right"
              >
                <Link to={'/copyright-reg'}>
                  <div className="service">
                    <div className="title">Register Your Copyrights</div>
                  </div>
                </Link>
                {/* <div className="service coming">
                  <div className="title">Performing Rights Registration</div>
                  <div className="details">Register your songs with ASCAP, BMI, SESAC and SOCAN</div>
                  <div className="coming-text">Coming soon!</div>
                </div> */}
              </OverlayTrigger>
            </div>
            <br />
          </Col>

          <Col md={12} sm={12}>
            <DealsList pageType="dashboard" />
          </Col>
        </Row>

        <PlanModal
          show={planModalOpen}
          subscriptionPlan={subscriptionPlan}
          referrer={profile.referrer}
          showCheckoutStep={true}
          showAllPlan={true}
          isPremiumExpired={isPremiumExpired}
          isCanceledSubscription={
            subscription &&
            subscription.status === 'Canceled' &&
            subscriptionPlan === 'free'
          }
          hidePlanModal={() => this.hidePlanModal()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  profile: state.profile,
  subscription: state.payment.subscription,
});

export default connect(mapStateToProps, null)(Dashboard);



// WEBPACK FOOTER //
// src/pages/Dashboard.jsx